import * as m from "mithril";
import CustomSvgIcon from "./CustomSvgIcon";

interface SpinnerBoxAttrs {
    initialValue: number;
    singularLabel: string;
    pluralLabel: string;
    minCount: number;
    maxCount: number;
    onCountChange: (value: number) => void;
}

interface SpinnerBoxState {
    value: number;
}

const SpinnerBox_: m.Component<SpinnerBoxAttrs, SpinnerBoxState> = {
    oninit(vnode) {
        vnode.state.value = vnode.attrs.initialValue;
    },

    view(vnode) {
        const { singularLabel, pluralLabel, minCount: min, maxCount: max, onCountChange } = vnode.attrs;
        const { value } = vnode.state;

        const label = value > 1 ? pluralLabel : singularLabel;

        const canDecrease = value > min;
        const canIncrease = value < max;

        return m("div", { class: "list-group list-group-horizontal shadow-sm" }, [
            // Minus button
            m(
                "button",
                {
                    class: "list-group-item d-flex align-items-center justify-content-center " +
                           (canDecrease ? "clickable" : "disabled"),
                    disabled: !canDecrease,
                    onclick: () => {
                        if (!canDecrease) return;
                        vnode.state.value -= 1;
                        onCountChange(vnode.state.value);
                    }
                },
                m(CustomSvgIcon, {
                    iconType: "minus",
                    themeCssClass: canDecrease
                        ? "svg-x-small svg-info stroke-info"
                        : "svg-x-small svg-disabled-muted stroke-disabled-muted"
                })
            ),

            // Display
            m(
                "div",
                { class: "list-group-item flex-fill text-center" },
                value + " - " + label
            ),

            // Plus button
            m(
                "button",
                {
                    class: "list-group-item d-flex align-items-center justify-content-center " +
                           (canIncrease ? "clickable" : "disabled"),
                    disabled: !canIncrease,
                    onclick: () => {
                        if (!canIncrease) return;
                        vnode.state.value += 1;
                        onCountChange(vnode.state.value);
                    }
                },
                m(CustomSvgIcon, {
                    iconType: "plus",
                    themeCssClass: canIncrease
                        ? "svg-small svg-info stroke-info"
                        : "svg-small svg-disabled-muted stroke-disabled-muted"
                })
            )
        ]);
    }
};

export default SpinnerBox_;
